/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { workspacesGetAnalytics } from "../../funcs/workspacesGetAnalytics.js";
import * as operations from "../../models/operations/index.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request:
    operations
      .GetApiWorkspaceServiceV1WorkspacesAnalyticsWorkspaceIdRequest$inboundSchema,
};

export const tool$workspacesGetAnalytics: ToolDefinition<typeof args> = {
  name: "workspaces_get-analytics",
  description: `Get workspace analytics`,
  args,
  tool: async (client, args, ctx) => {
    const [result, apiCall] = await workspacesGetAnalytics(
      client,
      args.request,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    const value = result.value;

    return formatResult(value, apiCall);
  },
};
